module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab1033-6b5d9d771342ad98bb227704bbbc7f61.jpg";